"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerCompanyDocs = exports.PartnerCompanyDocTypesEnum = void 0;
const typeorm_1 = require("typeorm/browser");
const decorators_1 = require("../data-ui/decorators");
const layouts_1 = require("../data-ui/layouts");
const contact_profile_enum_1 = require("./contact-profile-enum");
const partner_1 = require("./partner");
const nanoid_1 = require("nanoid");
var PartnerCompanyDocTypesEnum;
(function (PartnerCompanyDocTypesEnum) {
    PartnerCompanyDocTypesEnum["LIABILITY_INSURANCE"] = "liability_insurance";
    PartnerCompanyDocTypesEnum["PERSONAL_ID_CARD"] = "personal_id_card";
    PartnerCompanyDocTypesEnum["TRADE_LICENSE"] = "trade_license";
    PartnerCompanyDocTypesEnum["CRAFT_CARD"] = "craft_card";
    PartnerCompanyDocTypesEnum["TAX_EXEMPTION_ORDER"] = "tax_exemption_order";
})(PartnerCompanyDocTypesEnum = exports.PartnerCompanyDocTypesEnum || (exports.PartnerCompanyDocTypesEnum = {}));
let PartnerCompanyDocs = class PartnerCompanyDocs {
};
__decorate([
    decorators_1.DataUi.SearchField(),
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", String)
], PartnerCompanyDocs.prototype, "id", void 0);
__decorate([
    decorators_1.DataUi.SearchField(),
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.ManyToOne)(() => partner_1.Partner, (account) => account.companyDocs),
    (0, typeorm_1.JoinColumn)(),
    __metadata("design:type", partner_1.Partner)
], PartnerCompanyDocs.prototype, "account", void 0);
__decorate([
    decorators_1.DataUi.S3File({
        name: (i, index) => `partner/${i === null || i === void 0 ? void 0 : i.account.id}/company-documents/${(0, nanoid_1.nanoid)()}`,
        arrayMode: 'append',
    }),
    (0, typeorm_1.Column)({
        type: 'character varying',
    }),
    __metadata("design:type", String)
], PartnerCompanyDocs.prototype, "path", void 0);
__decorate([
    decorators_1.DataUi.EnumValues(PartnerCompanyDocTypesEnum),
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: PartnerCompanyDocTypesEnum,
    }),
    __metadata("design:type", String)
], PartnerCompanyDocs.prototype, "type", void 0);
__decorate([
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        name: 'lifetime_start',
        type: 'timestamp with time zone',
        nullable: true,
    }),
    __metadata("design:type", Date)
], PartnerCompanyDocs.prototype, "lifetimeStart", void 0);
__decorate([
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        name: 'lifetime_end',
        type: 'timestamp with time zone',
        nullable: true,
    }),
    __metadata("design:type", Date)
], PartnerCompanyDocs.prototype, "lifetimeEnd", void 0);
__decorate([
    decorators_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.Column)({
        nullable: true,
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], PartnerCompanyDocs.prototype, "confirmedAt", void 0);
__decorate([
    decorators_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], PartnerCompanyDocs.prototype, "createdAt", void 0);
__decorate([
    decorators_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], PartnerCompanyDocs.prototype, "updatedAt", void 0);
__decorate([
    decorators_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.DeleteDateColumn)({
        type: 'timestamp with time zone',
        nullable: true,
    }),
    __metadata("design:type", Date)
], PartnerCompanyDocs.prototype, "deletedAt", void 0);
PartnerCompanyDocs = __decorate([
    decorators_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
    }),
    decorators_1.DataUi.Name({
        name: 'Partner Company Docs',
        nameFunction: (i) => `${i.type} - ${i.account.name}`,
    }),
    decorators_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Check)('lifetime_range', `lifetime_start IS NULL OR lifetime_end IS NULL OR lifetime_start <= lifetime_end`),
    (0, typeorm_1.Entity)('partner_company_docs', { schema: 'public' })
], PartnerCompanyDocs);
exports.PartnerCompanyDocs = PartnerCompanyDocs;
//# sourceMappingURL=partner-company-docs.js.map